import InputAutocomplete from './InputAutocomplete';

export default InputAutocomplete;
